import styled from 'styled-components';
import { GridStyled } from '../GridStyled';

export const GridStyledOV = styled(GridStyled)``;
